






  import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
  import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue"
  import UiTaskHeaderComponent from '@/app/shared/components/ui/ui-task-header-component.vue'
  import { TranslateResult } from 'vue-i18n';
  import i18n from '@/plugins/i18n';

@Component({
  components: {
    UiTaskHeaderComponent,
    HelpPopupComponent
  }
})
export default class InteractionHeaderComponent extends Vue {
  
  @Prop({ required: true })
  public title: string | null;
  
  @Prop({ required: true })
  public instruction: string | null;

  @Prop({ required: true })
  public type: string | null;

  private get hasTaskHeader() {
    return this.title || this.instruction;
  }
  
  private helpPopupTitleLangKey() {
    return `interactive_component_question_tooltips.${this.type}.title`;
  }

  private helpPopupContentLangKey() {
    return `interactive_component_question_tooltips.${this.type}.content`;
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
